import { graphql } from 'gatsby';
import { StyledLogo, StyledLogoImage } from './Logo.styles';
import KontentImage from '@/components/KontentImage/KontentImage';

const IMAGE_WIDTH = 180;
const IMAGE_HEIGHT = 72;

const Logo = ({
  logo,
  altLogo = logo,
  isFlipped = false,
}: {
  logo: Queries.LOGOFragment;
  altLogo?: Queries.LOGOFragment;
  isFlipped?: boolean;
}) => {
  const { asset } = logo.value;
  const width = asset.value.width ?? IMAGE_WIDTH;
  const height = asset.value.height ?? IMAGE_HEIGHT;

  const { asset: altAsset } = altLogo.value;
  const altWidth = altAsset.value.width ?? IMAGE_WIDTH;
  const altHeight = altAsset.value.height ?? IMAGE_HEIGHT;

  return (
    <StyledLogo>
      <StyledLogoImage isVisible={!isFlipped}>
        <KontentImage
          sizes={[{ width, height, quality: 80 }]}
          alt={asset.value.description ?? ''}
          src={asset.value.url}
        />
      </StyledLogoImage>
      <StyledLogoImage isVisible={isFlipped}>
        <KontentImage
          sizes={[{ width: altWidth, height: altHeight, quality: 80 }]}
          alt={altAsset.value.description ?? ''}
          src={altAsset.value.url}
        />
      </StyledLogoImage>
    </StyledLogo>
  );
};

export const fragment = graphql`
  fragment LOGO on kontent_item_logo {
    id
    value {
      asset {
        value {
          description
          height
          type
          url
          width
        }
      }
    }
  }
`;

export default Logo;
